module.exports = __webpack_public_path__ + "images/003389162b6783c6f1649ad45c3c1679-drumwave_logo.png";